module.exports = __webpack_public_path__ + "img/mv03.8a5f2c28.png";